import React from "react";
import "./PaymentSuccessBox.scss";

const PaymentSuccessBox = () => {
  return (
    <div className="section-card success-box">
      ✅ Payment submitted
      <br />
      Please wait for confirmation
    </div>
  );
};

export default PaymentSuccessBox;
